import { render, staticRenderFns } from "./TMenuDivider.vue?vue&type=template&id=ad5c6de4&scoped=true&"
import script from "./TMenuDivider.vue?vue&type=script&lang=js&"
export * from "./TMenuDivider.vue?vue&type=script&lang=js&"
import style0 from "./TMenuDivider.vue?vue&type=style&index=0&id=ad5c6de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5c6de4",
  null
  
)

export default component.exports